// src/utils/TokenRefreshHandler.js

/**
 * Questa classe è ora un semplice 'helper'.
 * Il suo unico scopo è fornire una funzione 'refreshToken' pulita
 * che può essere chiamata dall'interceptor di axios.
 * NON gestisce più intervalli o stati interni.
 */
class TokenRefreshHandler {
    constructor() {
        // apiUrl verrà impostato dal file api.js
        this.apiUrl = '';
    }

    /**
     * Tenta di rinnovare il token chiamando l'endpoint dedicato.
     * @returns {Promise<boolean>} - true se il refresh è riuscito, false altrimenti.
     */
    async refreshToken() {
        const token = localStorage.getItem('token');
        if (!token) {
            console.warn('Refresh token: non trovato nessun token in localStorage.');
            return false;
        }

        try {
            // Usiamo fetch qui per evitare un ciclo infinito di interceptor di axios
            const response = await fetch(`${this.apiUrl}/refresh`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (response.ok) {
                const { token: newToken } = await response.json();
                localStorage.setItem('token', newToken);
                localStorage.setItem('tokenTimestamp', Date.now().toString());
                console.log('Token rinnovato con successo da TokenRefreshHandler.');
                return true;
            }

            // Se il refresh fallisce (es. 401), il token non è più valido
            console.warn(`Refresh fallito. Status: ${response.status}`);
            return false;

        } catch (error) {
            console.error('Errore di rete durante il refresh del token:', error);
            return false;
        }
    }
}

// Esporta un'istanza singleton
const tokenRefreshHandler = new TokenRefreshHandler();
export default tokenRefreshHandler;